/** Port of Bankfacil/vanilla-masker `toPattern` / `toNumber` (dependency removed). */

import { isObject, replace, split } from 'lodash';

const DIGIT = '9';
const ALPHA = 'A';
const ALPHANUM = 'S';

function addPlaceholdersToOutput(
  output: string[],
  index: number,
  placeholder: string,
): string[] {
  for (; index < output.length; index++) {
    const ch = output[index];
    if (ch === DIGIT || ch === ALPHA || ch === ALPHANUM) {
      output[index] = placeholder;
    }
  }
  return output;
}

type PatternOpts = { pattern: string; placeholder?: string };

export function toPattern(
  value: string | number,
  patternOrOpts: string | PatternOpts,
): string {
  const opts: PatternOpts = isObject(patternOrOpts)
    ? (patternOrOpts as PatternOpts)
    : { pattern: patternOrOpts };
  const pattern = opts.pattern;
  const placeholder = opts.placeholder;

  const patternChars = replace(pattern, /\W/g, '');
  const output = split(pattern, '');
  const values = replace(String(value), /\W/g, '');
  const charsValues = replace(values, /\W/g, '');
  let index = 0;
  let i;
  const outputLength = output.length;

  for (i = 0; i < outputLength; i++) {
    if (index >= values.length) {
      if (patternChars.length === charsValues.length) {
        return output.join('');
      }
      if (
        placeholder !== undefined &&
        patternChars.length > charsValues.length
      ) {
        return addPlaceholdersToOutput(output, i, placeholder).join('');
      }
      break;
    }
    const o = output[i];
    const v = values[index];
    if (
      (o === DIGIT && /[0-9]/.test(v)) ||
      (o === ALPHA && /[a-zA-Z]/.test(v)) ||
      (o === ALPHANUM && /[0-9a-zA-Z]/.test(v))
    ) {
      output[i] = v;
      index++;
    } else if (o === DIGIT || o === ALPHA || o === ALPHANUM) {
      if (placeholder !== undefined) {
        return addPlaceholdersToOutput(output, i, placeholder).join('');
      }
      return output.slice(0, i).join('');
    } else if (o === v) {
      index++;
    }
  }
  return output.join('').substring(0, i);
}

export function toNumber(value: string | number): string {
  return replace(String(value), /(?!^-)[^0-9]/g, '');
}
